import { CUSTOM_RANGE_LIMIT_IN_MONTHS } from '../../js/constants'

angular.module('surfsightApp.controllers').controller('EdgeReportDateFilter', [
  '$scope',
  '$timeout',
  '$interval',
  '$http',
  '$localStorage',
  '$mdDialog',
  '$mdToast',
  '$filter',
  function (
    $scope,
    $timeout,
    $interval,
    $http,
    $localStorage,
    $mdDialog,
    $mdToast,
    $filter
  ) {
    $scope.available_preset_options = []
    $scope.selected_tab = 0
    const $translate = $filter('translate')
    $scope.reset_available_preset_options = function () {
      var today = new Date()
      var this_month = {
        start: new Date(today.getFullYear(), today.getMonth(), 1).getTime(),
        end: new Date(today.getFullYear(), today.getMonth() + 1, 1).getTime()
      }
      var last_month = {
        start: new Date(today.getFullYear(), today.getMonth() - 1, 1).getTime(),
        end: new Date(today.getFullYear(), today.getMonth(), 1).getTime()
      }
      $scope.available_preset_options = [
        {
          id: 1,
          name: 'today',
          name_formate1: 'today',
          name_formate2: Date.today().toString('MMM dd '),
          current_year: Date.today().toString('yyyy'),
          date: {
            start: Date.today().getTime(),
            end: Date.today()
              .add(1)
              .day()
              .getTime()
          }
        },
        {
          id: 2,
          name: 'yesterday',
          name_formate1: 'yesterday',
          name_formate2: Date.today()
            .add(-1)
            .day()
            .toString('MMM dd '),
          current_year: Date.today().toString('yyyy'),
          date: {
            start: Date.today()
              .add(-1)
              .day()
              .getTime(),
            end: Date.today().getTime()
          }
        },
        {
          id: 3,
          name: 'pastWeek',
          name_formate1: 'pastWeek ',
          name_formate2: `${Date.today()
            .add(-6)
            .day()
            .toString('MMM dd ')} - ${Date.today().toString('MMM dd ')}`,
          current_year: Date.today().toString('yyyy'),
          date: {
            start: Date.today()
              .add(-6)
              .day()
              .getTime(),
            end: Date.today()
              .add(1)
              .day()
              .getTime()
          }
        },
        {
          id: 4,
          name: 'past30Days',
          name_formate1: 'past30Days ',
          // name_formate1:Date.today().add(-29).day().toString('MMM dd '),
          name_formate2: `${Date.today()
            .add(-29)
            .day()
            .toString('MMM dd ')} - ${Date.today().toString('MMM dd ')}`,
          // name_formate2: Date.today().toString('MMM dd '),
          current_year: Date.today().toString('yyyy'),
          date: {
            start: Date.today()
              .add(-30)
              .day()
              .getTime(),
            end: Date.today()
              .add(1)
              .day()
              .getTime()
          }
        }
      ]
      $timeout(function () {
        $scope.reset_available_preset_options()
      }, 1 * 60 * 1000)
    }
    $scope.reset_available_preset_options()
    $scope.changeSelectedTab = function (tab_index) {
      // ~ alert();
      $timeout(function () {
        $scope.selected_tab = tab_index
      })
    }
    $scope.select_preset_options = function (preset_option) {
      // console.log(preset_option);
      $mdDialog.hide(preset_option)
    }
    $scope.custom_range = {
      start: Date.today(),
      end: Date.today()
        .add(1)
        .day()
    }
    $scope.showMessageToast = function (message) {
      const toast = $mdToast
        .simple()
        .textContent(message)
        .action($translate('ok'))
        .actionKey('F1')
        .position('bottom')
        .parent('#edge-event-date-filter-container')
        .hideDelay(5000)

      $mdToast
        .show(toast)
        .then(function (response) {})
        .catch(() => {})
    }
    $scope.apply_custom_range = function () {
      var start_date_string = $scope.custom_range.start.toString(
        'ddd, dd MMM, yyyy'
      )
      var end_date_string = $scope.custom_range.end.toString(
        'ddd, dd MMM, yyyy'
      )
      if (
        moment($scope.custom_range.end).diff(
          moment($scope.custom_range.start),
          'months',
          true
        ) > CUSTOM_RANGE_LIMIT_IN_MONTHS
      ) {
        $scope.showMessageToast($translate('customRangeLimitExceededMessage'))
        return
      }
      var range_name = start_date_string + ' - ' + end_date_string
      if (start_date_string == end_date_string) {
        range_name = start_date_string
      }
      var selected_range = {
        name: range_name,
        name_formate1: '',
        name_formate2:
          $scope.custom_range.start.toString('dd MMM yyyy') +
          '-' +
          $scope.custom_range.end.toString('dd MMM yyyy'),
        date: {
          start: $scope.custom_range.start.getTime(),
          end: $scope.custom_range.end
            .add(1)
            .day()
            .getTime()
        }
      }
      $mdDialog.hide(selected_range)
      // ~ console.log(selected_range);
    }
  }
])
